import { render, staticRenderFns } from "./industryOverview.vue?vue&type=template&id=4ab32950&scoped=true"
import script from "./industryOverview.vue?vue&type=script&lang=js"
export * from "./industryOverview.vue?vue&type=script&lang=js"
import style0 from "./industryOverview.vue?vue&type=style&index=0&id=4ab32950&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab32950",
  null
  
)

export default component.exports